import {
  Box,
  HStack,
  Avatar,
  Button,
  // useColorMode,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaArrowAltCircleUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// import { FaSun, FaMoon } from "react-icons/fa";
import SearchBar from "./SearchBar";
import { HiOutlineSearch } from "react-icons/hi";
import { BiChevronDown } from "react-icons/bi";
import { PROTECTED_PATHS, PUBLIC_PATHS } from "routes/pagePath";
import { GiHamburgerMenu } from "react-icons/gi";

const NavBar = (props: any) => {
  const {
    handleLogout,
    onSearchChange,
    clickedSearchTerm,
    handleHide,
    searchData,
    user,
    searchText,
    showDropdown,
    setcurrentCat,
    currentCat,
    showSearch,
    setshowSearch,
    onOpenSideBar,
  } = props;
  const { DASHBOARD } = PROTECTED_PATHS;
  const history = useNavigate();

  return (
    <>
      <Box position="relative" zIndex="10">
        <Flex
          bg="primary"
          px={{ base: "6", md: "4", sm: "2", l: "10" }}
          py="2"
          alignItems="center"
          justify="space-between"
        >
          <Box w="100%" display={showSearch ? "block" : "none"}>
            {/* For mobile screen */}
            <SearchBar
              resultClick={clickedSearchTerm}
              searchText={searchText}
              onChange={onSearchChange}
              handleBack={() => setshowSearch(false)}
              showDropdown={showDropdown}
              hideDropdown={handleHide}
              handleHide={handleHide}
              searchResult={searchData}
              currentCat={currentCat}
              setcurrentCat={setcurrentCat}
            />
          </Box>

          <HStack w="60%" display={showSearch ? "none" : "flex"}>
            <Button
              aria-label="Open navigation menu"
              display={{ base: "flex", md: "none" }}
              onClick={() => {
                onOpenSideBar?.();
              }}
            >
              <GiHamburgerMenu />
            </Button>
            <Avatar
              name="softscript"
              src={"image"}
              onClick={() => {
                history(DASHBOARD);
              }}
              _hover={{
                cursor: "pointer",
              }}
              mr={4}
            />
            <Box
              w="100%"
              display={{
                base: "none",
                lg: "block",
              }}
            >
              {/* for desktop */}
              <SearchBar
                resultClick={clickedSearchTerm}
                showDropdown={showDropdown}
                searchText={searchText}
                onChange={onSearchChange}
                handleHide={handleHide}
                hideDropdown={handleHide}
                searchResult={searchData}
                currentCat={currentCat}
                setcurrentCat={setcurrentCat}
              />
            </Box>
          </HStack>
          <Box display={showSearch ? "none" : "flex"}>
            <Flex alignItems="center">
              <Button
                leftIcon={<FaArrowAltCircleUp />}
                mr={1}
                display={{ base: "none", lg: "flex" }}
                onClick={() => {
                  history(PROTECTED_PATHS.UPLOAD_ADMIN);
                }}
              >
                Review scripts
              </Button>
              {user.success ? (
                <Menu>
                  <MenuButton as="button">
                    <Flex alignItems="center" color="#fff">
                      <Avatar src={user.data.image} width="36px" height="36px" />
                      <Text mx={2} display={{ base: "none", md: "block" }}>
                        {user.data.userName}
                      </Text>
                      <BiChevronDown />
                    </Flex>
                  </MenuButton>
                  <MenuList>
                    <MenuItem>Profile</MenuItem>
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                  </MenuList>
                </Menu>
              ) : (
                <Button
                  onClick={() => {
                    history(PUBLIC_PATHS.LOGIN);
                  }}
                >
                  Log in
                </Button>
              )}
            </Flex>
            <Flex>
              <Button
                onClick={() => setshowSearch(true)}
                display={{
                  base: "block",
                  lg: "none",
                }}
              >
                <HiOutlineSearch />
              </Button>
              {/* removed the color toggle mode for now */}
              {/* <Button onClick={() => toggleColorMode()}>
      {colorMode === "light" ? <FaSun /> : <FaMoon />}
    </Button> */}
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default NavBar;
